module.exports = __webpack_public_path__ + "media/images/lb/456-4ae958974c0008e86fe24cfe33cfa6b7.svg";